import { type ActiveIntegration, ActiveFeedStatus } from '../types'

const STATUS_ORDER = {
	[ ActiveFeedStatus.CONNECTED ]: 1,
	[ ActiveFeedStatus.PENDING ]: 2,
	[ ActiveFeedStatus.DELAYED ]: 3,
	[ ActiveFeedStatus.UNRESPONSIVE ]: 4,
	[ ActiveFeedStatus.AUTH_FAILED ]: 5,
	[ ActiveFeedStatus.ACTION_NEEDED ]: 6,
	Inactive: 7,
	[ ActiveFeedStatus.STATUS_UNSPECIFIED ]: 8,
}

export const sortActiveIntegrationsByName = ( integrations: ActiveIntegration[] ) => {
	return integrations.sort( ( integrationA, integrationB ) => {
		return integrationA.name.localeCompare( integrationB.name )
	} )
}

export const sortActiveIntegrationsByDate = <K extends keyof ActiveIntegration>(
	integrations: ActiveIntegration[],
	sortProperty: K,
	reversed: boolean = false,
) => {
	return integrations.sort( ( integrationA, integrationB ) => {
		const integrationAValue = integrationA[ sortProperty ] as string | undefined
		const integrationBValue = integrationB[ sortProperty ] as string | undefined

		if ( !integrationAValue && !integrationBValue ) {
			return 0
		}
		if ( !integrationAValue ) {
			return reversed ? -1 : 1
		}
		if ( !integrationBValue ) {
			return reversed ? 1 : -1
		}

		const dateA = new Date( integrationAValue ).getTime()
		const dateB = new Date( integrationBValue ).getTime()

		return reversed ? dateA - dateB : dateB - dateA
	} )
}

export const sortActiveIntegrationsByStatus = ( integrations: ActiveIntegration[] ) => {
	return integrations.sort( ( integrationA, integrationB ) => {
		const statusA = integrationA.currentStatus ?? ActiveFeedStatus.STATUS_UNSPECIFIED
		const statusB = integrationB.currentStatus ?? ActiveFeedStatus.STATUS_UNSPECIFIED
		return ( STATUS_ORDER[ statusA ] ) - ( STATUS_ORDER[ statusB ] )
	} )
}

export const sortRequiredFieldsLogically = <T extends { fieldName: string }>( fields: T[] ) => {
	return fields.sort( ( a, b ) => {
		//sort by username first, then password, then client id, then client secret, then api key, then others alphabetically
		const order = [ 'username', 'password', 'client_id', 'client_secret', 'api_key' ]
		const aIndex = order.includes( a.fieldName ) ? order.indexOf( a.fieldName ) : order.length + a.fieldName.charCodeAt( 0 )
		const bIndex = order.includes( b.fieldName ) ? order.indexOf( b.fieldName ) : order.length + b.fieldName.charCodeAt( 0 )
		return aIndex - bIndex
	} )
}
